import { render, staticRenderFns } from "./antecedent-adulte-personnel.html?vue&type=template&id=01067f6a&scoped=true&external"
import script from "./antecedent-adulte-personnel.js?vue&type=script&lang=js&external"
export * from "./antecedent-adulte-personnel.js?vue&type=script&lang=js&external"
import style0 from "./antecedent-adulte-personnel.scss?vue&type=style&index=0&id=01067f6a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01067f6a",
  null
  
)

export default component.exports